<template>
    <div class="overflow-x-auto">
        <div :class="{ 'bg-neutral-lighter': dropdown } " class="text-sm">
            <div :class="{'container mx-auto': dropdown }" class="flex items-center">
                <span class="font-semibold w-full md:w-1/3 xl:w-2/5">{{ lang('Produkt','Product') }}</span>
                <span class="font-semibold hidden md:inline-flex md:w-1/4 xl:w-1/6">{{ lang('Bindningstid','Binding period') }}</span>
                <span class="font-semibold hidden md:inline-flex">{{ lang('Pris','Price') }}</span>
                <span class="font-semibold py-lg md:py-2xl" />
            </div>
        </div>
        <div :class="{'container mx-auto md:my-lg': dropdown }">
            <cart-item
                v-for="cartItem in cartData.displayItems"
                :key="cartItem.idHash"
                :cart-item="cartItem"
                :removeable="true"
                @cartDataUpdated="responseData => $emit('cartDataUpdated', responseData)"
            />
            <cart-item
                v-for="subItem in cartData.subItems"
                :key="subItem.idHash"
                :cart-item="subItem"
                @cartDataUpdated="responseData => $emit('cartDataUpdated', responseData)"
            />
        </div>
    </div>
</template>

<script>
    import CartItem from './CartItem';

    export default {
        components: {
            CartItem,
        },

        props: {
            cartData: {
                type: Object,
                required: true,
            },
            dropdown: {
                type: Boolean,
                required: true,
            },
        },
    };
</script>